import { registryModule } from '@beeline/lk-utils';

import { Service } from './Service';
import { Widget } from './Widget';

export function modules(): void {
  registryModule(Widget, 'bookworkplace/widget');
  registryModule(Service, 'bookworkplace/service');
}
